module.exports = __webpack_public_path__ + "543644dd0912ef74d1747572072f3567.svg";